import React, { useState, useEffect } from "react"
import * as styles from "./ProjectSynopsis.module.css"

import image1 from "../../images/on-going-projects/the-edge/gallery/01.png";
import image2 from "../../images/on-going-projects/the-edge/gallery/05.png";
import image3 from "../../images/on-going-projects/the-edge/gallery/09.png";
import image4 from "../../images/on-going-projects/the-edge/gallery/10.jpg";
import image5 from "../../images/on-going-projects/the-edge/gallery/08.png";
import image6 from "../../images/on-going-projects/the-edge/gallery/06.png";

const ProjectSynopsis = () => {
  const [activeSlide, setActiveSlide] = useState(0)

  const slides = [
    // "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/01+DAY+SIDE+(1).png",
    // "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/05+KIDS+PLAY.png",
    // "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/09+TERRACE.png",
    // "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/10+AERIAL+DAY.jpg",
    // "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/08+AMPHITHEATRE.png",
    // "https://billiontags-media.s3.ap-south-1.amazonaws.com/gopalapuram/06 BALCONY.png"

image1,
image2,
image3,
image4,
image5,
image6
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [slides.length])

  return (
    <section id="project-synopsis" className={styles.fiveSplitSection}>
      <div className={styles.contentBox}>
        <h2>Projects <span className={styles.cbr}>Synopsis</span></h2>
        <p>
          GOPALAPURAM EVERY TURN REEKS OF HISTORY - For long Gopalapuram, the neighbourhood has been
          credited with a rich tapestry of history and cultural highpoints. It has been home to an illustrious political
          doven and stalwart in the arts, literature and film arena. Your new distinct home here in its own right will now
          also garner its rightful place in the annals of opulent residential architecture
        </p>

        <div className={styles.textWrapper}>
          <div className={styles.textBox}>
            <h3>Adding grandeur to a grander address</h3>
            <p>
              Your ultra-luxurious residence has been painstakingly envisioned and crafted to
              resemble an architectural marvel that transcends time. The crux of the design
              vision is the cheerful chemistry of luxury, modernity and the neighbourhood's
              cultural essence. It is poised composedly to be a serene escape from the city's usual chaos. This
              residential masterpiece is a confluence of opulence and elegant design flair
            </p>
          </div>

          <div className={styles.textBox}>
            <h3>Architecture that's soulful and alive</h3>
            <p>
              Diligent care has been invested to proportionately blend sophistication
              with functionality. What will set this upscale residence apart is the layered
              stacking of units at various levels. This exudes a dynamic breath of fresh air.
              Punctuated by a louvered wrapped façade, the design concept resourcefully
              adopts a delicate interplay of shade and sunlight. This in turn accentuates the
              building's sleek silhouette offering a contemporary yet timeless appeal.
              The versatile façade adapts to the varying climate moods and interacts
              with the surrounding.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.splitSlider}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${styles.splitSlide} ${index === activeSlide ? styles.active : ''}`}
            style={{ '--bg': `url('${slide}')` }}
          >
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ProjectSynopsis
